module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/tokimeki_enshutsuka-a567c7bd7df96c101f925fd038a1736b.png";